import Ajax from '@/lib/ajax'
import getUrlConfig from '@/lib/urlConfig'

const api = getUrlConfig.api
const apiMg = getUrlConfig.apiMg

// -----------------------------------------planList
/**
 * 获取 质量控制计划备案列表页
 * @param {object} data
 */
export const planList = (data) =>
    Ajax.post(api + '/planList', data);
/**
 * 创建 质量控制计划检
 * @param {object} data
 */
export const planAdd = (data) =>
    Ajax.post(api + '/planAdd', data);
/**
 * 删除 质量控制计划检
 * @param {object} data
 */
export const planDelete = (data) =>
    Ajax.post(api + '/planDelete', data);
/**
 * 查看 质量控制计划退回意见
 * @param {object} data
 */
export const monitorOpinion = (data) =>
    Ajax.post(api + '/monitorOpinion', data);

// -----------------------------------------plan1
/**
 * 获取 修订说明
 * @param {object} data
 */
export const notesDetail = (data) =>
    Ajax.post(api + '/notesDetail', data);
/**
 * 保存 修订说明
 * @param {object} data
 */
export const notesSave = (data) =>
    Ajax.post(api + '/notesSave', data);
// -----------------------------------------plan2
/**
 * 获取 质量控制计划备案基本信息
 * @param {object} data
 */
export const monitorBaseInfo = (data) =>
    Ajax.post(api + '/monitorBaseInfo', data);
/**
 * 保存 质量控制计划备案基本信息
 * @param {object} data
 */
export const monitorBaseInfoSave = (data) =>
    Ajax.post(api + '/monitorBaseInfoSave', data);
/**
 * 获取 市、县
 * @param {object} data
 */
export const getArea = (data) =>
    Ajax.post(api + '/getArea', data);

/**
 * 获取核算指南行业分类
 * @param {object} data
 */
// export const getIndustry = (data) =>
//     Ajax.post(apiMg + '/getIndustry', data);

export const getLawGuideIndustry = (data) =>
    Ajax.post(api + '/getLawGuideIndustry', data);
// -----------------------------------------plan3
/**
 * 获取 机组列表
 * @param {object} data
 */
export const unitList = (data) =>
    Ajax.post(api + '/unitList', data);
/**
 * 保存 机组列表
 * @param {object} data
 */
export const unitSave = (data) =>
    Ajax.post(api + '/unitSave', data);
/**
 * 获取 合并填报的机组列表
 * @param {object} data
 */
export const getMergeUnit = (data) =>
    Ajax.post(api + '/getMergeUnit', data);
// -----------------------------------------plan4
/**
 * 获取 生产设施列表
 * @param {object} data
 */
export const productList = (data) =>
    Ajax.post(api + '/productList', data);
/**
 * 保存 生产设施列表
 * @param {object} data
 */
export const productSave = (data) =>
    Ajax.post(api + '/productSave', data);
/**
 * 新增 生产设施列表
 * @param {object} data
 */
export const productAdd = (data) =>
    Ajax.post(api + '/productAdd', data);
/**
 * 删除 生产设施列表
 * @param {object} data
 */
export const productDelete = (data) =>
    Ajax.post(api + '/productDelete', data);
/**
 * 获取 生产设施编号
 * @param {object} data
 */
export const GetFacilityCode = (data) =>
    Ajax.post(api + '/GetFacilityCode', data);
// -----------------------------------------plan5

/**
 * 获取 主营产品及生产工艺
 * @param {object} data
 */
export const proTechDetail = (data) =>
    Ajax.post(api + '/proTechDetail', data);
/**
 * 保存 主营产品及生产工艺
 * @param {object} data
 */
export const proTechSave = (data) =>
    Ajax.post(api + '/proTechSave', data);
// -----------------------------------------plan6
/**
 * 获取 核算边界的描述
 * @param {object} data
 */
export const accountBoundaryDescribeDetail = (data) =>
    Ajax.post(api + '/accountBoundaryDescribeDetail', data);
/**
 * 保存 核算边界的描述
 * @param {object} data
 */
export const accountBoundaryDescribeSave = (data) =>
    Ajax.post(api + '/accountBoundaryDescribeSave', data);
/**
 * 获取 主要排放设施
 * @param {object} data
 */
export const mainEmissionFacilityDetail = (data) =>
    Ajax.post(api + '/mainEmissionFacilityDetail', data);
/**
 * 保存 主要排放设施
 * @param {object} data
 */
export const mainEmissionFacilitySave = (data) =>
    Ajax.post(api + '/mainEmissionFacilitySave', data);
// -----------------------------------------plan7
/**
 * 获取 数据的确定方式
 * @param {object} data
 */
export const confirmMethodDetail = (data) =>
    Ajax.post(api + '/confirmMethodDetail', data);
/**
 * 新增 数据的确定方式
 * @param {object} data
 */
export const confirmMethodAdd = (data) =>
    Ajax.post(api + '/confirmMethodAdd', data);
/**
 * 保存 数据的确定方式
 * @param {object} data
 */
export const confirmMethodSave = (data) =>
    Ajax.post(api + '/confirmMethodSave', data);
/**
 * 同步填报 数据的确定方式
 * @param {object} data
 */
export const dataConfirmSyncFilling = (data) =>
    Ajax.post(api + '/dataConfirmSyncFilling', data);
// -----------------------------------------plan8
/**
 * 获取 数据内部质量控制
 * @param {object} data
 */
export const qualityControlDetail = (data) =>
    Ajax.post(api + '/qualityControlDetail', data);
/**
 * 保存 数据内部质量控制
 * @param {object} data
 */
export const qualityControlSave = (data) =>
    Ajax.post(api + '/qualityControlSave', data);
// -----------------------------------------plan9
/**
 * 获取 文件列表  发电行业
 * @param {object} data
 */
export const fileListService = (data) =>
    Ajax.post(api + '/fileListService', data);
/**
 * 获取 文件列表  非电行业
 * @param {object} data
 */
export const otherFileListService = (data) =>
    Ajax.post(api + '/otherFileListService', data);
/**
 * 删除 文件
 * @param {object} data
 */
export const fileDeleteService = (data) =>
    Ajax.post(api + '/fileDeleteService', data);
/**
 * 提交  计划监测备案
 * @param {object} data
 */
export const monitorLock = (data) =>
    Ajax.post(api + '/monitorLock', data);


// -----------------------------------------补充行业信息
/**
 * 新增或修改补充行业信息
 * @param {object} data
 */
export const supplementaryInfoSave = (data) =>
    Ajax.post(api + '/supplementaryInfoSave', data);
/**
 * 查询--补充行业信息
 * @param {object} data
 */
export const supplementaryInfoList = (data) =>
    Ajax.post(api + '/supplementaryInfoList', data);
/**
 * 删除--补充行业信息
 * @param {object} data
 */
export const supplementaryInfoDelete = (data) =>
    Ajax.post(api + '/supplementaryInfoDelete', data);



/**
*  预提交
* @param {object} data
*/
export const monitorPlanPreSubmit = (data) =>
    Ajax.post(api + '/monitorPlanPreSubmit', data);

/**
*  同步许可数据
* @param {object} data
*/
export const syncBaseInfoDataService = (data) =>
    Ajax.post(api + '/syncBaseInfoDataService', data);

/**
*  同步企业信息
* @param {object} data
*/
export const syncEnterInfoFromBaseService = (data) =>
    Ajax.post(api + '/syncEnterInfoFromBaseService', data);
    
/** 
 *智能校核-生成质量控制计划能校核数据：
 * @param {object} data
 */
 export const createMonitorAuditInfoService = (data) =>
 Ajax.post(api + '/createMonitorAuditInfoService', data);

 /**
 *智能校核-查询质量控制计划智能校核数据：
 * @param {object} data
 */
 export const getMonitorAuditInfoService = (data) =>
 Ajax.post(api + '/getMonitorAuditInfoService', data);

 /**
 *同步报告
 * @param {object} data
 */
 export const pullDataPlanInfoService = (data) =>
 Ajax.post(api + '/pullDataPlanInfoService', data);
